/**
 * Return font size roughly over half the size of the avatar
 * @param {number} size
 * @return {number} fontSize
 */
export default function getInitialsFontSize(avatarSize, size) {
  if (size && typeof size === 'string') {
    switch (size) {
      case 'xs':
        return 12;

      case 'sm':
        return 14;

      case 'md':
        return 16;

      case 'lg':
        return 20;

      default:
        return 16;
    }
  }

  return Math.ceil(avatarSize / 2.6);
}